import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=ee8f8c80&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=ee8f8c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8f8c80",
  null
  
)

export default component.exports